import { get as getCookie } from 'browser-cookies'

import GoogleOptimizeServiceFactory from './src/googleOptimizeService'

/**
 * Exports an instance of the GoogleOptimize class for usage inside the customer app. It gets injected
 * what it needs to behave properly in the app. Note that for unit testing purposes, you shouldn't
 * test this file directly because `browser-cookies` would be hard to mock.
 */

let instance

export default function googleOptimizeService() {
  if (!instance) {
    instance = GoogleOptimizeServiceFactory(getCookie)
  }

  instance.reloadTests(getCookie('_gaexp'))
  return instance
}
